import type { AgentAction, AgentPermission } from "./types";

/** The Canvas and Data Agents permissions, by action. */
export const customAgentPermissions: Record<AgentAction, AgentPermission> = {
  view: "viewCustomAgents",
  edit: "editCustomAgents",
  archive: "archiveCustomAgents",
};

/** The Agentic Standards permissions, by action. */
export const qaAgentPermissions: Record<AgentAction, AgentPermission> = {
  view: "viewQaAgents",
  edit: "editQaAgents",
  archive: "archiveQaAgents",
};
